// TODO(): type OutputAction payloads
export enum OutputAction {
  Handshake = 'Handshake',
  Logout = 'Logout',
  Restart = 'Restart',
  Downloads_GetAll = 'Downloads_GetAll',
  Download_Start = 'Download_Start',
  Download_Delete = 'Download_Delete',
  Download_Pause = 'Download_Pause',
  Download_Resume = 'Download_Resume',
  Download_Play = 'Download_Play',
  Download_Cancel = 'Download_Cancel',
  Download_Retry = 'Download_Retry',
  Settings_GetAll = 'Settings_GetAll',
  Settings_DownloadQuality = 'Settings_DownloadQuality',
  Settings_DownloadOnMobileData = 'Settings_DownloadOnMobileData',
  Settings_3PNotice = 'Settings_3PNotice',
  Settings_Feedback = 'Settings_Feedback',
  Profile_Switch = 'Profile_Switch',
  Profile_Switched = 'Profile_Switched',
  Profile_SwitchFailed = 'Profile_SwitchFailed',
  JS_Error = 'JS_Error'
}


export type JSErrorPayload = {
  message: string
  trace: string
  info?: string
}
